import { DependencyList, useContext, useEffect } from 'react'
import SocketContext from 'context/SocketContext'
import { Socket } from 'socket.io-client'

export default function useSocket<T>(
    ev: string,
    cb: (value: T) => void,
    deps: DependencyList = []
) {
    const socket = useContext(SocketContext)

    useEffect(() => {
        if (!socket) return
        socket.on(ev, cb)
        return () => {
            socket.off(ev)
        }
    }, [socket, ...deps])

    return socket as Socket<any, any>
}
